export enum ReactionType {
    Hello = '👋',
    Heart = '❤️',
    ThumbsUp = '👍',
    Clap = '👏',
    Party = '🎉',
    Fire = '🔥',
    Laugh = '🤣',
    Thinking = '🤔',
    Angry = '😠',
    ThumbsDown = '👎',
    Tears = '😭',
    Poop = '💩',
}

export interface Reaction {
    type: ReactionType;
    participantId: string;
    participantName: string;
    timestamp: number;
    id: string;
    colorIdentity: string;
    isFading?: boolean;
}

export interface ParticipantReaction {
    type: ReactionType;
    timestamp: number;
}
